import { PlatePluginOptions } from '@udecode/plate-core';

export const MARK_SUBSCRIPT = 'subscript';
export const DEFAULTS_SUBSCRIPT: Partial<PlatePluginOptions> = {
  hotkey: 'mod+.',
  clear: MARK_SUBSCRIPT,
};
